import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';


// import { columns } from './gridConfig';
// import { LinkContainer } from 'react-router-bootstrap';
import { Popconfirm, Tooltip, message } from 'antd';

// Local Deps
// import { editToolingManagementRoute } from '../../../config/navigation/routes';
import { deleteItem, getToolingManagementList } from '../../../graphql/item';
import EditToolingManagement from '../../Modals/EditToolingManagement';
import { LoadingTable } from '../../Loading';


import trashCan from '../../../images/trashcan.svg';
import edit from '../../../images/edit.svg';
import './ToolingManagementGrid.scss';

export default class ToolingManagementGrid extends Component {
  static propTypes = {
    auth: PropTypes.shape({
      jwtToken: PropTypes.string.isRequired,
      expiration: PropTypes.number.isRequired,
      organizationId: PropTypes.string.isRequired,
      role: PropTypes.string.isRequired,
      cageCode: PropTypes.string.isRequired,
      email: PropTypes.string,
    }).isRequired,
    // handleDelete: PropTypes.func.isRequired,
    toolFilter: PropTypes.array,
  };

  static defaultProps = {
    toolFilter: undefined,
  };

  static initialState = {
    tools: [],
    hits: 0,
    page: 0,
    pages: 0,
    errors: [],
    isLoading: true,
    toolFilter: undefined,
    showTable: true,
    pageSize: 20,
    sorted: [
      { id: 'partNum', desc: false }
    ],
    selectedItemId: undefined,
    showEditModal: false,
  };
  state = ToolingManagementGrid.initialState;

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.toolFilter !== prevState.toolFilter) {
      return { toolFilter: nextProps.toolFilter };
    }
    return null;
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.toolFilter !== this.state.toolFilter) {
      this.remountTable()
    }
  }
  remountTable() {
    this.setState({ showTable: false })
    setTimeout(() => this.setState({ showTable: true }), 5)
  }

  retrieveToolsByCage = async (page, pageSize, sorted) => {
    this.setState({ isLoading: true });
    const { cageCode } = this.props.auth;
    const filter = this.props.toolFilter;
    const offset = page * pageSize;
    let tools = [];
    let hits = 0;
    try {
      const { toolingSearch } = await getToolingManagementList(cageCode, offset, pageSize, sorted, filter);
      tools = toolingSearch.itemList || [];
      hits = toolingSearch.hits || 0;
    } catch (error) {
      message.error("Failed to retrieve Tooling List from Database.");
    }

    if (tools.length > 0) {
      let i;
      for (i = 0; i < tools.length; i++) {
        tools[i].accessLevel = Object.values(JSON.parse(tools[i].accessLevel))[0];
        tools[i].category = `${Object.keys(JSON.parse(tools[i].category))[0].toString()}-${Object.values(JSON.parse(tools[i].category))[0].toString()}`;
      }
    }
    const pages = Math.ceil(hits / pageSize)
    this.setState({ tools, hits, pages, isLoading: false });
  };

  onPageChange = page => {
    this.setState({ page });
  };

  onPageSizeChange = pageSize => {
    this.setState({ pageSize });
  };

  onSortedChange = sorted => {
    this.setState({ sorted });
  };

  handleDelete = async id => {
    const { email } = this.props.auth;
    try {
      const {
        deleteItem: { status },
      } = await deleteItem(id, email, "T");
      if (status === 'success') {
        message.success('Tool Successfully Deleted!');
        this.reloadItems();
      }
    } catch (error) {
      message.error('Could not Delete Tool');
    }
  };

  closeEditModal = () => {
    this.setState({
      showEditModal: false,
      selectedItemId: undefined,
    });
  }

  reloadItems = async () => {
    await this.retrieveToolsByCage(this.state.page, this.state.pageSize, this.state.sorted);
  }

  openEditModal = (itemId) => {
    this.setState({
      showEditModal: true,
      selectedItemId: itemId,
    });
  }

  render() {
    const { tools, hits, pages, pageSize, sorted, isLoading } = this.state;
    // const { handleDelete } = this.props;
    const columns = [
      {
        Header: 'Part No',
        accessor: 'partNum',
        minWidth: 120,
      },
      {
        Header: 'NSN',
        accessor: 'niin',
        minWidth: 120,
      },
      {
        Header: 'Description',
        accessor: 'description',
        minWidth: 120,
      },
      {
        Header: 'Tooling Ref No',
        accessor: 'toolingRef',
        minWidth: 100,
      },
      {
        Header: 'Tooling CAGE',
        accessor: 'ownerCage',
        minWidth: 65,
      },
      {
        Header: 'Design-Alloy',
        accessor: 'designAlloy',
        minWidth: 120,
      },
      {
        Header: 'Visibility',
        accessor: 'accessLevel',
        minWidth: 120,
      },
      {
        Header: 'Category',
        accessor: 'category',

        Cell: cellProps => (
          <div>
            <Tooltip title={cellProps.value.split('-')[1]}>{cellProps.value.split('-')[0]}</Tooltip>
          </div>
        ),
        minWidth: 60,
      },
      {
        Header: 'Comments',
        accessor: 'comments',
        minWidth: 120,
      },
      {
        Header: 'Action',
        accessor: 'action',
        minWidth: 80,
        sortable: false,
        filterable: false,
        Cell: cellProps => (
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-around',
            }}
          >
            <button
              onClick={() => {
                this.openEditModal(cellProps.original.id);
              }}
              className="tooling-action"
            >
              <img src={edit} alt="Edit" />
            </button>

            <Popconfirm
              title="Are you sure you want to delete this item? This action cannot be undone!"
              onConfirm={() => this.handleDelete(cellProps.original.id)}
              okText="Yes"
              cancelText="No"
            >
              <button className="tooling-action">
                <img src={trashCan} alt="delete" />
              </button>
            </Popconfirm>
          </div>
        ),
      },
    ];

    return (
      <Fragment>
        <div className="nf-tooling-mgmt-grid">
          {this.state.showTable &&
            <Fragment>
              <div>
                <p style={{ fontWeight: '600' }}>Found {hits} Results</p>
              </div>
              <ReactTable
                data={tools}
                pages={pages}
                columns={columns}
                noDataText='No toolings found'
                defaultPageSize={pageSize}
                minRows={3}
                showPagination
                showPaginationBottom
                showPageJump
                pageSizeOptions={[20, 50, 100, 250, 500]}
                manual // this indicates that server side pagination has been enabled 
                onPageChange={this.onPageChange}
                onPageSizeChange={this.onPageSizeChange}
                onSortedChange={this.onSortedChange}
                // filterable
                defaultSorted={sorted}
                // multiSort={false}
                loading={isLoading}
                LoadingComponent={LoadingTable}
                onFetchData={(state) => {
                  this.retrieveToolsByCage(state.page, state.pageSize, state.sorted)
                }}
              />
            </Fragment>
          }
        </div>
        {this.state.showEditModal && this.state.selectedItemId &&
          <EditToolingManagement
            selectedItemId={this.state.selectedItemId}
            showEditModal={this.state.showEditModal}
            auth={this.props.auth}
            closeEditModal={this.closeEditModal}
            reloadItems={this.reloadItems}
          />
        }

      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/grids/ToolingManagementGrid/ToolingManagementGrid.jsx